import type { FaireProductEntity } from "../../entity_types/product";

export const p_efkazfbquf: FaireProductEntity = {
  token: "p_efkazfbquf",
  type: "product",
  name: "Pizza squishy**no box**",
  brandToken: "b_ny7c7awd6p",
  brandName: "UPSCALE FREEZE",
  imageUrl:
    "https://cdn.faire.com/fastly/553be51cfba229c4c192fb1a01e62e79e40f43976eed8aafff50088e8e89c52a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4799557a892efe8abb54c31e04660f52cf2ab23009fd616cf5ea74fd8e277513.png",
  ],
  priceDollars: 6,
  description:
    "Viral pizza squishy        \n**NOT BRANDED SQUISHIES**       \n**colors may vary**\n**please be sure when ordering, as we do not cancel orders due to this negatively affecting our analytics here on the platform*    \n\n**orders after 6/22/26 will not have boxes**    ",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:50.304Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
